<p-panel>
    <h4>Datos del producto de {{nameModule}}</h4>

    <app-reactive-form-builder
        (goBack)="goBack()"
        [form]="form.formFields"
        [id]="getModel().id ?? ''"
        [request]="this.getType() === 1 ? this.productApi.productos.PUT : this.productApi.productos.POST"
        [getRequest]="productApi.productos.GET">
    </app-reactive-form-builder>
</p-panel>
<br>
